export default __webpack_public_path__ + "static/media/users.4346cb37.svg";